<div data-app-submission-links [(urls)]="urls" [readonly]="readonly"></div>
<button class="button" (click)="readonly = !readonly">
  <span *ngIf="readonly">Allow Edits</span>
  <span *ngIf="!readonly">Prevent Edits</span>
</button>
